export default "__VITE_ASSET__Cexntksg__"